import { labels } from '../globals/config';
import switchStep from '../components/switchStep';
import { apSwitchStep } from '../../appointment-tool/components/apSwitchStep';
import apAnalytics from '../../appointment-tool/components/apAnalytics';
import qtAnalytics, { handleImpressions } from '../components/qtAnalytics';
import apAnalyticsErrors from '../../appointment-tool/components/analyticsErrors';
import analyticsErrors from '../components/analyticsErrors';

const $ = jQuery;

export const userInfoData = {
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    contactPreference: '',
    marketingConsent: false,
};

export function userInfo() {
    userInfoSubmit();
}

/**
 * Validate user info fields.
 * @returns {boolean}
 */
function validateUserInfo() {
    const validationElements = $('#firstname, #lastname, #phone');
    const $email = $('#email');
    let valid = true;
    let analyticsErrorTexts = [];

    validationElements.each(function (i, element) {
        valid = validateEmptyFields(element);

        if (!valid) {
            let elementId = $(element).attr('id');

            switch (elementId) {
                case 'firstname':
                    analyticsErrorTexts.push('First name field can’t be empty');
                    break;
                case 'lastname':
                    analyticsErrorTexts.push('Last name field can’t be empty');
                    break;
                case 'phone':
                    analyticsErrorTexts.push('Phone number field can’t be empty');
                    break;
            }
        }
    });

    if ($email.val()) {
        let validationObject = validateEmail($email);

        if (validationObject.failed) {
            valid = false;
            analyticsErrorTexts.push('Invalid email address');

            $email.parent().addClass('error');
            $email.siblings('.js-qt-user-info-error-message').text(validationObject.message);
        } else {
            $email.parent().removeClass('error');
            $email.siblings('.js-qt-user-info-error-message').text(validationObject.message);
        }
    } else {
        valid = false;
        analyticsErrorTexts.push('Email field can’t be empty');
        $email.parent().addClass('error');
        $email.siblings('.js-qt-user-info-error-message').text(labels.emptyField);
    }

    // Join all error texts for analytics error tracking

    if (!valid) {
        analyticsErrorTexts = analyticsErrorTexts.join(' | ');
        submitError('personal-info', 5, 'user-error', '', analyticsErrorTexts);
        handleImpressions('incomplete');
    }

    return valid;
}

/**
 * Validate email field.
 * @param inputField
 * @returns {{failed: boolean, message: string}}
 */
function validateEmail(inputField) {
    let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

    if (inputField.val().length <= 0) {
        return {
            failed: true,
            message: labels.emptyField,
        };
    } else if (!String(inputField.val()).match(mailFormat)) {
        return {
            failed: true,
            message: labels.invalidEmail,
        };
    } else {
        return {
            failed: false,
            message: '',
        };
    }
}

/**
 * Validate empty fields.
 * @param inputField
 * @returns {boolean}
 */
function validateEmptyFields(inputField) {
    const $inputField = $(inputField);

    if ($inputField.val().length <= 0) {
        $inputField.parent().addClass('error');
        $inputField.siblings('.js-qt-user-info-error-message').text(labels.emptyField);
        return false;
    } else {
        $inputField.parent().removeClass('error');
        $inputField.siblings('.js-qt-user-info-error-message').text('');
        return true;
    }
}

/**
 * Submit user info.
 */
function userInfoSubmit() {
    $('#quote-tool, #appointment-tool').on('click', '.js-qt-user-info--submit', function () {
        if (validateUserInfo()) {
            const isConsentChecked = $('#marketing-consent').is(':checked');
            userInfoData.marketingConsent = isConsentChecked;

            userInfoData.firstname = $('#firstname').val();
            userInfoData.lastname = $('#lastname').val();
            userInfoData.phone = $('#phone').val();
            userInfoData.email = $('#email').val();
            userInfoData.contactPreference = $('#contact-preference').val();
            userInfoData.contactPreferenceText = $('#contact-preference option:selected').text();

            if ($('#quote-tool').length > 0) {
                qtAnalytics('personal-info-submit');
                switchStep('summary');
            }

            if ($('#appointment-tool').length > 0) {
                apAnalytics('personal-info--submit');
                apSwitchStep('summary');
            }
        }
    });
}

function submitError(type, step, errorType, option, message) {
    if ($('#quote-tool').length > 0) {
        analyticsErrors(type, 6, errorType, option, message);
    }

    if ($('#appointment-tool').length > 0) {
        apAnalyticsErrors(type, step, errorType, option, message);
    }
}
